import { useTranslation } from 'react-i18next';
import { Button } from '#components/Input/Button';
import { LoadMoreWrapper } from './styles';

export const LoadMore = ({
  onLoadMore,
  isLoading,
}: {
  onLoadMore: () => void;
  isLoading: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <LoadMoreWrapper>
      <Button
        variant="secondary"
        onClick={() => {
          onLoadMore();
        }}
        isLoading={isLoading}
      >
        {t('component.table.footer.load.more')}
      </Button>
    </LoadMoreWrapper>
  );
};
